function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.0703101mm",
    height: "7.6533117mm",
    viewBox: "0 0 5.0703101 7.6533117",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55.979659,-58.209545)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 56.459148,59.670486 q -0.112305,-0.190429 -0.170899,-0.356445 -0.05859,-0.170898 -0.05859,-0.3125 0,-0.239258 0.141601,-0.332031 0.146485,-0.09766 0.527344,-0.09766 0.0049,0 0.825195,0.02441 0.825196,0.02441 1.645508,0.02441 0.429688,0 0.727539,-0.03906 0.297852,-0.03906 0.532227,-0.12207 0.09277,0.146484 0.131836,0.273437 0.03906,0.122071 0.03906,0.249024 0,0.34668 -0.693359,1.499023 -0.688477,1.152344 -1.064453,1.90918 -0.522461,1.040039 -0.761719,1.738281 -0.239258,0.69336 -0.239258,1.152344 0,0.01953 0.0049,0.09277 0.0049,0.06836 0.0049,0.117188 -0.19043,0.05859 -0.336914,0.08789 -0.141602,0.03418 -0.22461,0.03418 -0.253906,0 -0.380859,-0.12207 -0.126953,-0.117188 -0.126953,-0.351563 0,-0.46875 0.517578,-1.547851 0.517578,-1.083984 2.290039,-4.130859 -0.273437,-0.02442 -0.595703,-0.03418 -0.317383,-0.01465 -0.732422,-0.01465 -0.74707,0 -1.240234,0.06348 -0.488282,0.06348 -0.761719,0.195312 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit7);
export default __webpack_public_path__ + "static/media/digit-7.141ab63c8b9c5c1d8f0a3076fc7ed58f.svg";
export { ForwardRef as ReactComponent };